import { queryOptions } from '@tanstack/react-query';
import { PackCompletion, PackTier } from '../../types/packs';
import { ApiError } from '~/components/Providers/APIClient';
import { ChangelogResponse } from '../../types/changelog';
import { IDLLevel } from '../../types/levels';
import { apiQueryFn } from '../utils';
import { PaginatedQuery } from '~/util/types/api';

export type packsQueryParams = {
    list: 'classic' | 'platformer';
    authed?: boolean;
};

export const packsQuery = ({ list, authed }: packsQueryParams) =>
    queryOptions<PackTier[], ApiError>({
        queryKey: ['packs', list, authed],
        queryFn: apiQueryFn<PackTier[]>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/pack-tiers`,
            attachAuth: true,
        }),
    });

export const packCompletionsQuery = ({
    list,
    packId,
}: {
    list: 'classic' | 'platformer';
    packId: string;
}) =>
    queryOptions<PackCompletion[], ApiError>({
        queryKey: ['packs', 'completions', list, packId],
        queryFn: apiQueryFn<PackCompletion[]>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/packs/${packId}/victors`,
            attachAuth: true,
        }),
    });

export type changelogQueryParams = {
    list: 'classic' | 'platformer';
} & PaginatedQuery;

export const changelogQuery = ({ list, page }: changelogQueryParams) =>
    queryOptions<ChangelogResponse, ApiError>({
        queryKey: ['changelog', list, page],
        queryFn: apiQueryFn<ChangelogResponse>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/changelog`,
            query: { page: page, per_page: 20 },
        }),
    });

export const idlQuery = () =>
    queryOptions<IDLLevel[], Error>({
        queryKey: ['list_idl'],
        queryFn: async (): Promise<IDLLevel[]> => {
            const response = await fetch(
                'https://insanedemonlist.com/api/levels',
            );
            if (!response.ok) {
                throw new Error('IDL failed to load');
            }
            return response.json();
        },
    });
